import { render } from "./Revenue.vue?vue&type=template&id=4ece35a2"
import script from "./Revenue.vue?vue&type=script&lang=js"
export * from "./Revenue.vue?vue&type=script&lang=js"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__